import SHARED_STYLES from 'json/shared_styles.json';
export var plot_config = {
  SHARED_STYLES: SHARED_STYLES,
  PRICE_GRAPH_TOTAL_HEIGHT: SHARED_STYLES.pricesGraph.height,
  NUMBER_OF_Y_TICKS: 6,
  Y_AXIS_LABEL: 'C$/kWh',
  Y_AXIS_LABEL_X: 0,
  Y_AXIS_LABEL_Y: -10,
  HOVER_DATE_TOP_MARGIN: -20,
  HOVER_DATE_SIDE_PADDING: 9,
  HOVER_DATE_TOP_BOTTOM_PADDING: 7,
  MAIN_NODE_SIZE: 8,
  SURROUNDING_NODE_SIZE: 4,
  PREVIOUS: 'previous',
  NEXT: 'next',
  CURRENT: 'current',
  TOOLTIP_X_MARGIN: 50,
  TOOLTIP_Y_MARGIN: 5,
  TOOLTIP_SIDE_PADDING: 9,
  TOOLTIP_TOP_BOTTOM_PADDING: 7
};
export var margin = {
  top: 60,
  right: 20,
  bottom: 70,
  left: 30
};
export var marginBrush = {
  top: 530,
  bottom: 10,
  left: 30
};